import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { CorrespondenceItem } from './correspondence-item';
export { CorrespondenceItem };
import { correspondenceItemSchema } from '@schemas/business-objects/correspondence-item';
import { UserFormGroup } from './user-form-group';

export class CorrespondenceItemFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    subject: SchemaFormControl;
    body: SchemaFormControl;
    senderId: SchemaFormControl;
    sender: UserFormGroup;
    recipientId: SchemaFormControl;
    recipient: UserFormGroup;
  };

  declare value: Partial<CorrespondenceItem>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(correspondenceItemSchema, CorrespondenceItem, data, options);
  }

  get object(): CorrespondenceItem {
    return new CorrespondenceItem(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'sender':
        return new UserFormGroup();
      case 'recipient':
        return new UserFormGroup();
      default:
        return undefined;
    }
  }
}

export class CorrespondenceItemFormArray extends PersistedFormArray {
  readonly entityName = 'CorrespondenceItem' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(correspondenceItemSchema, CorrespondenceItem, options);
  }

  protected override createItemGroup() {
    return new CorrespondenceItemFormGroup();
  }

  get array(): CorrespondenceItem[] {
    return this.controls.map(
      (group: CorrespondenceItemFormGroup) => group.object,
    );
  }
}

export class CorrespondenceItemPersistedArray extends PersistedArray<CorrespondenceItem> {
  readonly entityName = 'CorrespondenceItem' as const;

  constructor(options?: PersistedArrayOptions) {
    super(CorrespondenceItem, options);
  }
}
